import { Book, Cart, CartListItem } from './interfaces';

export const contextContainsProduct = (
  cart: Cart<Book>,
  bookCart: Book,
): CartListItem<Book> | undefined => {
  return cart.cartItems.find((item: CartListItem<Book>) => item.product.id === bookCart.id);
};

export const findIndexOfProduct = (cart: Cart<Book>, bookCart: Book): number => {
  return cart.cartItems.findIndex((item: CartListItem<Book>) => item.product.id === bookCart.id);
};
